const e = "Action timed out. Please check your internet connection and try again.", s = { 400: "This email address is not registered on $t(_company). Please make sure it is correct or sign up below.", 404: "$t(responses.login.400)", 500: "$t(responses.default)", 2009: "Please check your email address or sign up" }, o = { 400: "$t(responses.default)", 500: "$t(responses.default)" }, t = { 2033: "Successfully created session.", 2064: "Successfully updated session." }, a = { 200: "Successfully created your first session.", 201: "$t(responses.dashboardSession.200)" }, n = { 2084: "Session access request was already in approved state", 2088: "You've already requested access to this session.", email: { 200: "People added" }, domain: { 200: "Group added" } }, r = { 200: "Great! We'll keep you up to date." }, i = { 400: "The verification code is incorrect. Please double check.", 404: "$t(responses.default)", 405: "The verification code is incorrect. Please double check.", 500: "$t(responses.default)" }, c = { 500: "Sorry, something went wrong. Please try again.", avatar: { 400: "Error saving avatar. Please try again." } }, l = { 2140: "Meeting link unavaialble. Please choose another" }, d = {
  default: "Sorry, something went wrong. Please try again.",
  timeout: e,
  login: s,
  register: o,
  session: t,
  dashboardSession: a,
  sessionAccess: n,
  subscribe: r,
  verify: i,
  user: c,
  lobby: l
};
export {
  a as dashboardSession,
  d as default,
  l as lobby,
  s as login,
  o as register,
  t as session,
  n as sessionAccess,
  r as subscribe,
  e as timeout,
  c as user,
  i as verify
};
